import Vue from 'vue'
import VuetableFieldCheckbox from 'vuetable-2/src/components/VuetableFieldCheckbox.vue'
import numeral from 'numeral'
import i18n from '@/plugins/i18n';
import { convertTimezone } from "@/common/tenancy/convertTimezone";

function formatNumberDigit(value) {
    return numeral(value).format("0,0.00");
}

function convertTimezoneDate(date) {
    return date != null && new Date(date) instanceof Date && !isNaN(new Date(date)) ? convertTimezone.utcToLocal(date) : '-';
}

export default [
    {
        id: 'carrier',
        name: 'carrier',
        title: i18n.t('_ShippingChargeBillingReport.Carrier'),
        filterable: false,
        togglable: false,
    },
    {
        id: 'tracking_code',
        name: 'tracking_code',
        title: i18n.t('Tracking No.'),
        filterable: true,
        togglable: false,
    },
    {
        id: 'order_number',
        name: 'order_number',
        title: i18n.t('_ShippingChargeBillingReport.Order No'),
        filterable: true,
        togglable: false,
    },
    {
        id: 'destination_fullname',
        name: 'destination_fullname',
        title: i18n.t('_ShippingChargeBillingReport.Receiver'),
        filterable: true,
        togglable: false,
    },
    {
        id: 'destination_telephone1',
        name: 'destination_telephone1',
        title: i18n.t('Phone'),
        filterable: true,
        togglable: true,
        formatter: (data) => {
            return data;
        }
    },
    {
        id: 'shipment_status',
        name: 'shipment_status',
        title: i18n.t('Shipping Status'),
        filterable: true,
        togglable: true,
        formatter: (data) => {
            if(data == 'packing'){
                return '<span class="badge bg-warning-400"><i class="fas fa-solid fa-box-open-full"></i>'+i18n.t('Packing')+'</span>';
            }else if(data == 'ready_to_ship'){
                return '<span class="badge bg-blue-800"><i class="fas fa-solid fa-truck-clock"></i>'+i18n.t('Ready to Ship')+'</span>';
            }else if(data == 'shipping'){
                return '<span class="badge bg-success"><i class="fas fa-solid fa-thumbs-up"></i>'+i18n.t('Shipping')+'</span>';
            }else if(data == 'delivered'){
                return '<span class="badge bg-success"><i class="fas fa-solid fa-thumbs-up"></i>'+i18n.t('Delivered')+'</span>';
            }else if(data == 'returned'){
                return '<span class="badge bg-return"><i class="fa-solid fa-rotate-left"></i>'+i18n.t('Return')+'</span>';
            }else {
                return data;
            }
        }
    },
    {
        id: 'estimate_weight',
        name: 'estimate_weight',
        title: i18n.t('_ShippingChargeBillingReport.Estimate Weight'),
        filterable: true,
        togglable: true,
        formatter: (data) => {
            if(data == null || data == ''){
                return '0 g';
            }else{
                return numeral(data).format("0,0.00")+' g';
            }
        }
    },
    {
        id: 'estimate_price',
        name: 'estimate_price',
        title: i18n.t('_ShippingChargeBillingReport.Estimate Price'),
        filterable: true,
        togglable: true,
        formatter: (data) => {
            return formatNumberDigit(data);
        }
    },
    {
        id: 'actual_price',
        name: 'actual_price',
        title: i18n.t('Actual Price'),
        filterable: true,
        togglable: true,
        formatter: (data) => {
            return formatNumberDigit(data);
        }
    },
    {
        id: 'estimate_cod_amount',
        name: 'estimate_cod_amount',
        title: i18n.t('_ShippingChargeBillingReport.COD Amount'),
        filterable: true,
        togglable: true,
        formatter: (data) => {
            return formatNumberDigit(data);
        }
    },
    {
        id: 'estimate_cod_fee',
        name: 'estimate_cod_fee',
        title: i18n.t('_ShippingChargeBillingReport.COD Fee'),
        filterable: true,
        togglable: true,
        formatter: (data) => {
            return formatNumberDigit(data);
        }
    },
    {
        id: 'estimate_remote_price',
        name: 'estimate_remote_price',
        title: i18n.t('Remote Area Fee'),
        filterable: true,
        togglable: true,
        formatter: (data) => {
            return formatNumberDigit(data);
        }
    },
    {
        id: 'estimate_tourism_price',
        // name: 'estimate_tourism_price',
        title: i18n.t('Tourism Price'),
        filterable: true,
        togglable: true,
        formatter: (data) => {
            let result = data.actual_tourism_price > 0 ? data.actual_tourism_price : (parseFloat(data.estimate_island_price) + parseFloat(data.estimate_tourism_price))
            return formatNumberDigit(result);
        }
    },
    {
        id: 'estimate_total_price',
        // name: 'estimate_total_price',
        title: i18n.t('_ShippingChargeBillingReport.Total Estimate Shipping'),
        filterable: true,
        togglable: true,
        formatter: (data) => {
            let estimateTotalPrice = parseFloat(data.estimate_price) + parseFloat(data.estimate_cod_fee) + parseFloat(data.estimate_remote_price) + parseFloat(data.estimate_tourism_price) + parseFloat(data.estimate_on_holiday_price) + parseFloat(data.estimate_warranty_price) + parseFloat(data.estimate_island_price)
            return formatNumberDigit(estimateTotalPrice);
        }
    },
    {
        id: 'actual_weight',
        name: 'actual_weight',
        title: i18n.t('_ShippingChargeBillingReport.Actual Weight'),
        filterable: true,
        togglable: true,
        formatter: (data) => {
            if(data == null || data == ''){
                return '0 g';
            }else{
                return numeral(data).format("0,0.00")+' g';
            }
        }
    },
    {
        id: 'actual_return_price',
        name: 'actual_return_price',
        title: i18n.t('Return Price'),
        filterable: true,
        togglable: true,
        formatter: (data) => {
            return formatNumberDigit(data);
        }
    },
    {
        id: 'actual_total_price',
        // name: 'actual_total_price',
        title: i18n.t('_ShippingChargeBillingReport.Total Actual Shipping'),
        filterable: true,
        togglable: true,
        formatter: (data) => {
            let actualTotalPrice = parseFloat(data.actual_price) + parseFloat(data.actual_cod_fee) + parseFloat(data.actual_remote_price) + parseFloat(data.actual_tourism_price) + parseFloat(data.actual_on_holiday_price) + parseFloat(data.actual_warranty_price) + parseFloat(data.actual_return_price)
            return formatNumberDigit(actualTotalPrice);
        }
    },
    {
        id: 'size_calculate',
        // name: 'refund_charge',
        title: i18n.t('Size'),
        filterable: true,
        togglable: true,
        formatter: (data) => {
            if (data.size_calculate == null || data.size_calculate == '') {
                return '-'
            }
            let calculate = data.size_calculate == 'plus' ? '+' : '*'
            return `${numeral(data.actual_width).format("0,0.00")}${calculate}${numeral(data.actual_length).format("0,0.00")}${calculate}${numeral(data.actual_height).format("0,0.00")}`;
        }
    },
    {
        id: 'refund_charge',
        name: 'refund_charge',
        title: i18n.t('_ShippingChargeBillingReport.Refund/Charge'),
        filterable: true,
        togglable: true,
    },
    {
        id: 'topack_date',
        name: 'topack_date',
        title: i18n.t('_ShippingChargeBillingReport.Generate Tracking Date'),
        filterable: true,
        togglable: true,
        width:'150px',
        formatter: (data) => {
            if(data == null || data == ''){
                return '-';
            }else{
                return convertTimezoneDate(data);
            }
        }
    },
    {
        id: 'shipped_date',
        name: 'shipped_date',
        title: i18n.t('Shipping Date'),
        filterable: true,
        togglable: false,
        formatter: (data) => {
            if(data == null || data == ''){
                return '-';
            }else{
                return convertTimezoneDate(data);
            }
        }
    },
    {
        id: 'order_date',
        name: 'order_date',
        title: i18n.t('Orders Date'),
        filterable: true,
        togglable: true,
        width:'150px',
        formatter: (data) => {
            if(data == null || data == ''){
                return '-';
            }else{
                return convertTimezoneDate(data);
            }
        }
    },
    {
        id: 'return_tracking_number',
        name: 'return_tracking_number',
        title: i18n.t('_ShippingChargeBillingReport.Reference Tracking No'),
        filterable: true,
        togglable: false,
        formatter: (data) => {
            if(data == null || data == ''){
                return '-';
            }else{
                return data;
            }
        }
    },
];



// WEBPACK FOOTER //
// ./src/components/tenancy/admin/report/assets/js/ShippingExpensesDetail_fields.js